import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  constructor(private http: HttpClient) {}

  sendNotification(data: any) {
    return this.http.post(
      environment.apiUrl + "admin/sendPromotionNotification",
      data,
    );
  }

  addImage(file: any) {
    const formData = new FormData();
    formData.append("files", file);
    return this.http.post(environment.filePath, formData);
  }

  getNotificationHistory(data: any) {
    return this.http.post(
      environment.apiUrl + "admin/getNotificationHistory",
      data,
    );
  }
}
